<template>
  <div :class="eventClass" :style="background">
    <div class="inner-content" v-if="election.title.rendered">
      <Alert></Alert>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
import Alert from '@/components/Utils/Alert.vue'

export default {
  name: 'ElectionDetail',
  components: { Alert },

  mounted () {
    this.fetchElection()
  },

  methods: {
    fetchElection () {
      this.$store.commit('setLoading', true)
      this.$store.dispatch('getElection', this.$route.params.slug).catch(() => {
      }).finally(() => {
        this.$store.commit('setLoading', false)
        this.chooseTab()
      })
    },

    // Choose a tab (sub-view) to display based on what sections the event has
    chooseTab () {
      const tabs = {
        'election-rules': this.election.rules.length > 0,
        'election-candidates': this.election.candidates_new.length > 0 || this.election.candidates.length > 0,
        'election-voting': this.election.questionnaire.length > 0
      }

      for (let [name, exists] of Object.entries(tabs)) {
        if (exists) {
          this.$router.replace({ name, params: { slug: this.$route.params.slug } })
          break;
        }
      }
    }
  },

  computed: {
    isCordova () {
      return this.$store.getters.isCordova
    },

    election () {
      return this.$store.getters.election
    },

    eventClass () {
      return this.$route.name === 'event' ? 'event' : 'event ' + this.$route.name
    },

    background () {
      if (this.$route.name === 'election' && this.election.background) {
        let bg = this.election.background.url
        return bg !== false ? { 'background-image': 'url(' + bg + ')' } : false
      } else {
        return {}
      }
    },

    headerClass () {
      return this.$route.name === 'event' ? 'header-full' : 'header-collapsed'
    },

    userIsEditor () {
      return this.$store.getters.loggedIn &&
        (this.$store.getters.user.roles.indexOf('editor') > -1 ||
          this.$store.getters.user.roles.indexOf('administrator') > -1)
    }
  },

  beforeRouteLeave (to, from, next) {
    this.$store.commit('clearTitle')
    this.$store.commit('clearAlert')
    this.$store.commit('clearTabs')
    next()
  },
}
</script>
